export async function isApplicationTrafficReleased(fetchImpl: typeof fetch = fetch): Promise<boolean> {
  try {
    const response = await fetchImpl('/api/health', { cache: 'no-store' });
    if (!response.ok)
      return false;
    const body = await response.json() as { maintenanceMode?: string };
    return body.maintenanceMode === 'released';
  } catch {
    return false;
  }
}
